var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRigLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.3 27.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #78bd43;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #78787b;\n      }\n\n      .cls-3 {\n        fill: #1a478c;\n      }\n\n      .cls-4 {\n        fill: #0ea0db;\n      }\n\n      .cls-5 {\n        fill: #fcb421;\n      }\n\n      .cls-6 {\n        fill: #f26632;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.93,10.9v-6.69h-.03l-1.44,6.69h-1.74l-1.47-6.69h-.03v6.69H0V.14h3.2l1.36,6.22h.03L6.04.14h3.1v10.77h-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.76,5.54c0-3.31.87-5.54,3.81-5.54s3.81,2.22,3.81,5.54-1.07,5.5-3.81,5.5-3.81-2.07-3.81-5.5ZM14.82,5.54c0-2.54-.33-3.46-1.24-3.46s-1.25.93-1.25,3.46.38,3.45,1.25,3.45,1.24-.79,1.24-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.54,10.9L17.07.14h2.71l1.2,7.12h.03L22.33.14h2.69l-2.54,10.77h-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.14,10.9V.14h2.52v10.77h-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.34,10.9l-2.73-5.95h-.03v5.95h-2.22V.14h2.61l2.36,5.34h.03V.14h2.25v10.77h-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.49,10.9v-.78h-.03c-.62.69-1.29.91-2.12.91-2.01,0-3.12-1.53-3.12-5.59,0-3.09,1.02-5.44,3.78-5.44,2.43,0,3.21,1.55,3.43,3.51l-2.29.21c-.15-.98-.46-1.58-1.14-1.58-.79,0-1.21.78-1.21,3.3s.24,3.52,1.27,3.52c.75,0,1.16-.58,1.16-1.42v-.35h-1.17v-1.89h3.42v5.59h-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.16,10.9V.14h1.31v10.77h-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.75,10.9l-3.78-8.56h-.03v8.56h-1.18V.14h1.75l3.22,7.42h.03V.14h1.2v10.77h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.57,2.91c-.24-1.14-.69-1.74-1.65-1.74-.9,0-1.45.49-1.45,1.38,0,2.44,4.45,2.14,4.45,5.65,0,1.81-1.12,2.83-2.92,2.83s-2.61-.91-2.96-2.85l1.22-.21c.24,1.32.7,1.89,1.78,1.89.99,0,1.62-.55,1.62-1.56,0-2.62-4.39-2.28-4.39-5.69,0-1.65,1.04-2.62,2.65-2.62,1.71,0,2.55,1.01,2.79,2.7l-1.14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.92.14h1.29v7.47c0,2.23-.96,3.42-3.12,3.42s-3.04-1.19-3.04-3.42V.14h1.31v7.66c0,1.47.54,2.06,1.74,2.06s1.83-.58,1.83-2.06V.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.33,10.9l-1.8-4.74h-1.65v4.74h-1.29V.14h2.49c2.31,0,3.36.9,3.36,2.86,0,1.43-.66,2.31-1.7,2.71l2.01,5.19h-1.42ZM73.2,5c.92,0,1.92-.33,1.92-1.88s-.9-1.8-2.04-1.8h-1.2v3.67h1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.75,10.9l-.69-3.06h-2.94l-.67,3.06h-1.31L79.69.14h1.82l2.58,10.77h-1.33ZM79.39,6.65h2.4l-1.19-5.31h-.03l-1.19,5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.04,10.9l-3.78-8.56h-.03v8.56h-1.18V.14h1.75l3.22,7.42h.03V.14h1.2v10.77h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.67,7.42c-.33,2.43-1.3,3.61-3.12,3.61-2.37,0-3.25-2.01-3.25-5.56,0-3.33.99-5.48,3.29-5.48,1.8,0,2.68,1.17,2.98,3.39l-1.2.12c-.27-1.58-.84-2.29-1.79-2.29-1.3,0-1.98,1.4-1.98,4.26,0,3.06.58,4.36,1.96,4.36,1.05,0,1.63-.83,1.88-2.53l1.23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.84,10.9V.14h5.13v1.21h-3.84v3.38h2.85v1.19h-2.85v3.78h4.07v1.21h-5.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.01,
    y: 14.23,
    width: 20.76,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.08,
    y: 14.23,
    width: 20.76,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.16,
    y: 14.23,
    width: 20.76,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 63.23,
    y: 14.23,
    width: 20.76,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84.41,
    y: 14.23,
    width: 20.76,
    height: 2.04
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.01,26.05v-6.46h1.6c1.48,0,2.15.49,2.15,1.68,0,.68-.3,1.12-.84,1.37v.02c.73.26.99.81.99,1.54,0,1.49-.96,1.85-2.22,1.85H.01ZM1.65,22.27c.55,0,1.04-.2,1.04-.91s-.51-.82-1.04-.82h-.59v1.73h.59ZM1.76,25.1c.75,0,1.07-.26,1.07-.96s-.36-.99-1.06-.99h-.71v1.95h.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.13,27.68c-.18,0-.38,0-.53-.04v-.83c.17.02.29.02.39.02.46,0,.67-.19.82-.74l.04-.17-1.39-4.56h1.08l.76,3.16h.02l.72-3.16h1.01l-1.29,4.7c-.35,1.26-.75,1.61-1.64,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.54,26.05l-.93-2.66h-.82v2.66h-1.07v-6.46h1.71c1.39,0,2.05.53,2.05,1.79,0,.82-.35,1.32-.91,1.58l1.12,3.1h-1.16ZM12.4,22.48c.49,0,.99-.17.99-1,0-.91-.51-.96-1-.96h-.6v1.96h.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.05,26.13c-1.13,0-1.67-.75-1.67-2.45,0-1.51.58-2.4,1.69-2.4,1.21,0,1.64.96,1.64,2.16,0,.14,0,.29,0,.46h-2.4c.04.98.24,1.44.8,1.44.43,0,.67-.3.8-.78l.8.16c-.25.99-.8,1.41-1.65,1.41ZM16.3,23.21h1.49c0-.69-.22-1.16-.72-1.16-.47,0-.7.41-.77,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.67,26.05v-6.46h.96v6.46h-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.59,23.73c0-1.62.56-2.45,1.73-2.45s1.71.83,1.71,2.45-.59,2.4-1.71,2.4-1.73-.74-1.73-2.4ZM24.04,23.73c0-1.09-.2-1.66-.72-1.66s-.74.57-.74,1.66.21,1.62.74,1.62.72-.51.72-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.12,24.63c-.23,1.04-.71,1.5-1.64,1.5-1.19,0-1.68-.85-1.68-2.41,0-1.4.46-2.44,1.72-2.44.94,0,1.4.48,1.57,1.47l-.86.14c-.13-.52-.31-.79-.69-.79-.51,0-.77.63-.77,1.63,0,1.2.25,1.6.76,1.6.4,0,.61-.24.76-.87l.84.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.12,26.05l-.05-.5c-.37.38-.78.58-1.27.58-.66,0-1.05-.45-1.05-1.23,0-.53.19-.94.59-1.23.36-.28.95-.48,1.68-.69.05-.61-.08-.91-.56-.91-.4,0-.62.23-.76.65l-.77-.19c.21-.76.67-1.24,1.58-1.24,1.02,0,1.44.49,1.44,1.48v2.41l.07.88h-.91ZM32,23.65c-.51.14-.8.26-1.01.43-.19.15-.26.4-.26.68,0,.35.15.58.46.58s.6-.17.81-.45v-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.03,26.03c-.23.04-.47.07-.74.07-.77,0-1.06-.29-1.06-1.18v-2.75h-.62v-.8h.62v-1.52h.95v1.52h.86v.8h-.86v2.58c0,.33.13.47.41.47.14,0,.3-.02.45-.06v.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.88,20.61v-1.06h.99v1.06h-.99ZM36.89,26.05v-4.68h.96v4.68h-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.82,23.73c0-1.62.56-2.45,1.73-2.45s1.71.83,1.71,2.45-.59,2.4-1.71,2.4-1.73-.74-1.73-2.4ZM41.27,23.73c0-1.09-.2-1.66-.72-1.66s-.74.57-.74,1.66.21,1.62.74,1.62.72-.51.72-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.45,26.05v-3.14c0-.51-.15-.72-.49-.72-.25,0-.5.14-.78.47v3.39h-.95v-4.68h.93v.56c.39-.43.75-.65,1.22-.65.4,0,.68.15.83.42.15.24.19.58.19,1.1v3.25h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.52,26.05v-6.46h1.07v6.46h-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.07,26.05v-3.14c0-.51-.15-.72-.49-.72-.25,0-.5.14-.78.47v3.39h-.96v-4.68h.93v.56c.39-.43.75-.65,1.22-.65.4,0,.68.15.83.42.15.24.19.58.19,1.1v3.25h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.03,22.61c-.15-.42-.36-.58-.68-.58s-.5.19-.5.46c0,.86,2.06.69,2.06,2.3,0,.86-.58,1.33-1.51,1.33s-1.32-.38-1.55-1.22l.78-.22c.16.47.37.68.77.68.35,0,.58-.19.58-.5,0-.99-2.04-.8-2.04-2.34,0-.76.53-1.26,1.39-1.26s1.25.39,1.45,1.13l-.76.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62,26.05v-.56c-.4.43-.76.64-1.23.64-.4,0-.67-.14-.82-.41-.15-.24-.2-.59-.2-1.1v-3.25h.97v3.14c0,.51.13.72.48.72.24,0,.49-.13.77-.47v-3.39h.96v4.68h-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.1,26.05v-4.68h.93v.77c.31-.56.61-.86,1.11-.86.04,0,.09,0,.15.02v.98c-.07,0-.14-.02-.19-.02-.46,0-.79.28-1.04.8v2.99h-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.13,26.05l-.05-.5c-.37.38-.78.58-1.27.58-.66,0-1.05-.45-1.05-1.23,0-.53.19-.94.59-1.23.36-.28.95-.48,1.68-.69.05-.61-.08-.91-.56-.91-.4,0-.62.23-.76.65l-.77-.19c.21-.76.67-1.24,1.58-1.24,1.02,0,1.44.49,1.44,1.48v2.41l.07.88h-.91ZM69,23.65c-.51.14-.8.26-1.01.43-.19.15-.26.4-.26.68,0,.35.15.58.46.58s.6-.17.81-.45v-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.33,26.05v-3.14c0-.51-.15-.72-.49-.72-.25,0-.5.14-.78.47v3.39h-.95v-4.68h.93v.56c.39-.43.75-.65,1.22-.65.4,0,.68.15.83.42.15.24.19.58.19,1.1v3.25h-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.52,24.63c-.23,1.04-.71,1.5-1.64,1.5-1.19,0-1.68-.85-1.68-2.41,0-1.4.46-2.44,1.72-2.44.94,0,1.4.48,1.57,1.47l-.86.14c-.13-.52-.31-.79-.69-.79-.51,0-.77.63-.77,1.63,0,1.2.25,1.6.76,1.6.4,0,.61-.24.76-.87l.84.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.88,26.13c-1.12,0-1.67-.75-1.67-2.45,0-1.51.59-2.4,1.69-2.4,1.22,0,1.64.96,1.64,2.16,0,.14,0,.29,0,.46h-2.4c.04.98.24,1.44.8,1.44.43,0,.67-.3.8-.78l.8.16c-.25.99-.8,1.41-1.65,1.41ZM80.14,23.21h1.49c0-.69-.22-1.16-.72-1.16-.47,0-.7.41-.76,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.44,26.05v-.52h-.02c-.34.44-.77.6-1.29.6-1.24,0-1.89-.95-1.89-3.32,0-1.91.58-3.3,2.12-3.3,1.27,0,1.76.84,1.92,2.07l-.99.09c-.14-.77-.41-1.2-.93-1.2-.68,0-1.04.67-1.04,2.34s.27,2.39,1.05,2.39c.61,0,.94-.49.94-1.18,0-.1,0-.22,0-.32h-.95v-.86h1.94v3.21h-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.45,26.05v-4.68h.93v.77c.31-.56.61-.86,1.11-.86.04,0,.09,0,.15.02v.98c-.07,0-.14-.02-.19-.02-.46,0-.79.28-1.04.8v2.99h-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.17,23.73c0-1.62.56-2.45,1.73-2.45s1.71.83,1.71,2.45-.59,2.4-1.71,2.4-1.73-.74-1.73-2.4ZM95.62,23.73c0-1.09-.2-1.66-.72-1.66s-.74.57-.74,1.66.21,1.62.74,1.62.72-.51.72-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.79,26.05v-.56c-.4.43-.76.64-1.23.64-.4,0-.67-.14-.82-.41-.15-.24-.2-.59-.2-1.1v-3.25h.97v3.14c0,.51.13.72.48.72.24,0,.49-.13.77-.47v-3.39h.96v4.68h-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.88,27.6v-6.23h.93v.55c.29-.4.6-.64,1.11-.64.88,0,1.39.71,1.39,2.4s-.52,2.42-1.46,2.42c-.44,0-.75-.19-1.01-.49v1.99h-.96ZM102.84,24.85c.18.24.41.39.69.39.53,0,.78-.5.78-1.57,0-.98-.26-1.49-.76-1.49-.24,0-.53.16-.72.47v2.2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigLogo);
export default __webpack_public_path__ + "static/media/RIG_logo.c580946ba125c32b77bca74e35b94e2f.svg";
export { ForwardRef as ReactComponent };